// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hostname-table {
  display: flex;
  flex-direction: column;
  gap: 24px;
}
.hostname-table .action-bar {
  width: 100%;
}
.hostname-table .icon-error {
  color: #fd4445;
  margin-left: 12px;
}
.hostname-table .icon-success {
  color: #33B889;
  margin-left: 12px;
}
.hostname-table .hostname-actions {
  display: flex;
  gap: 8px;
}
.hostname-table .hostname-actions .edit-hostname {
  cursor: pointer;
}
.hostname-table .hostname-actions .disabled {
  cursor: not-allowed;
}
.hostname-table .cec-table .cec-table-container table tbody > tr > td {
  height: 65px;
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/HostnameTable/HostnameTable.less"],"names":[],"mappings":"AAEA;EACC,aAAA;EACA,sBAAA;EACA,SAAA;AADD;AAFA;EAME,WAAA;AADF;AALA;EAUE,cAAA;EACA,iBAAA;AAFF;AATA;EAeE,cAAA;EACA,iBAAA;AAHF;AAbA;EAoBE,aAAA;EACA,QAAA;AAJF;AAjBA;EAwBG,eAAA;AAJH;AApBA;EA4BG,mBAAA;AALH;AAvBA;EAiCE,YAAA;EACA,YAAA;AAPF","sourcesContent":["@import (reference) \"../../Styles/colors\";\n\n.hostname-table {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 24px;\n\n\t.action-bar {\n\t\twidth: 100%;\n\t}\n\n\t.icon-error {\n\t\tcolor: @error;\n\t\tmargin-left: 12px;\n\t}\n\n\t.icon-success {\n\t\tcolor: @success;\n\t\tmargin-left: 12px;\n\t}\n\n\t.hostname-actions {\n\t\tdisplay: flex;\n\t\tgap: 8px;\n\n\t\t.edit-hostname {\n\t\t\tcursor: pointer;\n\t\t}\n\n\t\t.disabled {\n\t\t\tcursor: not-allowed;\n\t\t}\n\t}\n\n\t.cec-table .cec-table-container table tbody > tr > td {\n\t\theight: 65px;\n\t\twidth: 100px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
